import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Box
} from '@mui/material';

const ModalMembership = ({ open, onClose, onSubmit, mode, form, setForm, membership }) => {
  const isView = mode === 'view';
  const isEdit = mode === 'edit';
  const isAdd = mode === 'add';

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <Dialog open={open} onClose={(e, reason) => {
      if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
      onClose();
    }} maxWidth="sm" fullWidth disableEscapeKeyDown>
      <DialogTitle>
        {isAdd && 'Aggiungi Tesseramento'}
        {isEdit && 'Modifica Tesseramento'}
        {isView && 'Dettagli Tesseramento'}
      </DialogTitle>
      <DialogContent>
        <Box component="form" sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
          <TextField
            name="name"
            label="Nome"
            value={isView ? membership?.name : form.name}
            onChange={handleChange}
            required
            fullWidth
            InputProps={{ readOnly: isView }}
          />
          <TextField
            name="description"
            label="Descrizione"
            value={isView ? membership?.description : form.description}
            onChange={handleChange}
            required
            fullWidth
            multiline
            minRows={2}
            InputProps={{ readOnly: isView }}
          />
          <TextField
            name="amount"
            label="Importo"
            type="number"
            value={isView ? membership?.amount : form.amount}
            onChange={handleChange}
            required
            fullWidth
            InputProps={{ readOnly: isView }}
          />
          <FormControl fullWidth>
            <InputLabel>Valuta</InputLabel>
            <Select
              name="currency"
              value={isView ? membership?.currency : form.currency}
              onChange={handleChange}
              label="Valuta"
              disabled={isView}
            >
              <MenuItem value="EUR">EUR</MenuItem>
            </Select>
          </FormControl>
          <TextField
            name="startDate"
            label="Data Inizio"
            type="date"
            value={isView ? (membership?.startDate ? membership.startDate.slice(0,10) : '') : form.startDate}
            onChange={handleChange}
            required
            fullWidth
            InputLabelProps={{ shrink: true }}
            InputProps={{ readOnly: isView }}
          />
          <TextField
            name="endDate"
            label="Data Fine"
            type="date"
            value={isView ? (membership?.endDate ? membership.endDate.slice(0,10) : '') : form.endDate}
            onChange={handleChange}
            required
            fullWidth
            InputLabelProps={{ shrink: true }}
            InputProps={{ readOnly: isView }}
          />
          <FormControl fullWidth>
            <InputLabel>Stato</InputLabel>
            <Select
              name="status"
              value={isView ? membership?.status : form.status}
              onChange={handleChange}
              label="Stato"
              disabled={isView}
            >
              <MenuItem value="draft">Bozza</MenuItem>
              <MenuItem value="published">Pubblicata</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Annulla</Button>
        {!isView && (
          <Button onClick={onSubmit} variant="contained">
            {isAdd ? 'Aggiungi' : 'Salva'}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ModalMembership; 